import React, { lazy, Suspense } from 'react';
import {getCookie} from '@iso/lib/helpers/session';

import {
  Route,
  Redirect,
  BrowserRouter as Router,
  Switch,
  useLocation
} from 'react-router-dom';
import { useSelector } from 'react-redux';

import ErrorBoundary from './ErrorBoundary';
import { PUBLIC_ROUTE } from './route.constants';
import Loader from '@iso/components/utility/loader';

const Dashboard = lazy(() => import('./containers/Dashboard/Dashboard'));
// const User_Dashboard = lazy(() => import('./containers/Fronend/Dashboard/Dashboard'));

const publicRoutes = [
  {
    path: PUBLIC_ROUTE.LANDING,
    exact: true,
    component: lazy(() => import('@iso/containers/Pages/Homepage/Homepage')),
  },
  {
    path: PUBLIC_ROUTE.USER_DASHBOARD,
    exact: true,
    component: lazy(() => import('@iso/containers/Frontend/Dashboard/Dashboard')),
  },
  {
    path: PUBLIC_ROUTE.LOG_IN,
    exact: true,
    component: lazy(() => import('@iso/containers/Pages/LogIn/LogIn')),
  },
  {
    path: PUBLIC_ROUTE.PAGE_404,
    exact: true,
    component: lazy(() => import('@iso/containers/Pages/404/404')),
  },
  {
    path: PUBLIC_ROUTE.PAGE_500,
    component: lazy(() => import('@iso/containers/Pages/500/500')),
  },
  {
    path: PUBLIC_ROUTE.SIGN_IN,
    exact: true,
    component: lazy(() => import('@iso/containers/Pages/SignIn/SignIn')),
  },
  {
    path: PUBLIC_ROUTE.SIGN_UP,
    exact: true,
    component: lazy(() => import('@iso/containers/Pages/SignUp/SignUp')),
  },
  {
    path: PUBLIC_ROUTE.ADMIN,
    exact: true,
    component: lazy(() => import('@iso/containers/Pages/Admin/Admin')),
  },
  {
    path: PUBLIC_ROUTE.ADMIN_LOGIN,
    exact: true,
    component: lazy(() => import('@iso/containers/Pages/Admin/AdminSignin')),
  },
  {
    path: PUBLIC_ROUTE.FIRST_LOGIN,
    exact: true,
    component: lazy(() => import('@iso/containers/Pages/firstLogin/firstLogin')),
  },
  {
    path: PUBLIC_ROUTE.FORGET_PASSWORD,
    exact: true,
    component: lazy(() =>
      import('@iso/containers/Pages/ForgotPassword/ForgotPassword')
    ),
  },
  {
    path: PUBLIC_ROUTE.RESET_PASSWORD,
    exact: true,
    component: lazy(() =>
      import('@iso/containers/Pages/ResetPassword/ResetPassword')
    ),
  },
  {
    path: PUBLIC_ROUTE.AUTH0_CALLBACK,
    component: lazy(() =>
      import('@iso/containers/Authentication/Auth0/Auth0Callback')
    ),
  },
  {
    path: PUBLIC_ROUTE.BECOME_SHAREHOLDER,
    exact: true,
    component: lazy(() =>
      import('@iso/containers/Frontend/BecomeShareholder/BecomeShareholder')
    ),
  },
  {
    path: PUBLIC_ROUTE.LEGAL_REPRESENTATIVE,
    exact: true,
    component: lazy(() =>
      import('@iso/containers/Frontend/BecomeShareholder/LegalRepresentative')
    ),
  },
  {
    path: PUBLIC_ROUTE.INVESTER_ONBOARDING,
    exact: true,
    component: lazy(() =>
      import('@iso/containers/Frontend/BecomeShareholder/StepSlider')
    ),
  },
  {
    path: PUBLIC_ROUTE.BUYSHARES,
    exact: true,
    component: lazy(() =>
      import('@iso/containers/Frontend/BuyShare')
    ),
  },
  {
    path: PUBLIC_ROUTE.SELLSHARES,
    exact: true,
    component: lazy(() =>
      import('@iso/containers/Frontend/SellShare')
    ),
  }, 
  {
    path: PUBLIC_ROUTE.TRANSFERSHARES,
    exact: true,
    component: lazy(() =>
      import('@iso/containers/Frontend/TransferShare')
    ),
  },
  {
    path: PUBLIC_ROUTE.DASHBOARD,
    exact: true,
    component: lazy(() =>
      import('@iso/containers/Frontend/Frontend_dashboard')
    ),
  },
  {
    path: PUBLIC_ROUTE.DIVIDEND_PREFERENCES,
    exact: true,
    component: lazy(() =>
      import('@iso/containers/Frontend/Dividend_Prefrences')
    ),
  },
  {
    path: PUBLIC_ROUTE.DOCUMENTS,
    exact: true,
    component: lazy(() =>
      import('@iso/containers/Frontend/Documents')
    ),
  },
  {
    path: PUBLIC_ROUTE.AUDIT_TRAIL,
    exact: true,
    component: lazy(() =>
      import('@iso/containers/Frontend/Audit_Trail')
    ),
  },
  {
    path: PUBLIC_ROUTE.CONTACTINFORMATION,
    exact: true,
    component: lazy(() =>
      import('@iso/containers/Frontend/ContactInformation')
    ),
  },
  {
    path: PUBLIC_ROUTE.NEXTSTEP,
    exact: true,
    component: lazy(() =>
      import('@iso/containers/Frontend/NextStep')
    ),
  },
  // {
  //   path: PUBLIC_ROUTE.QRCODE,
  //   // exact: true,
  //   component: lazy(() =>
  //     import('@iso/containers/Frontend/QrCode')
  //   ),
  // },
    {
      path: PUBLIC_ROUTE.BLANKPAGE,
      component: lazy(() =>
        import('@iso/containers/BlankPage')
      ),
  }, 
  {
    path: PUBLIC_ROUTE.REDIRECT,
    component: lazy(() =>
      import('@iso/containers/Pages/Redirect/Redirect')
    ),
}, 
{
  path: PUBLIC_ROUTE.REDIRECTONBOARD,
  component: lazy(() =>
    import('@iso/containers/Pages/Redirect/Redirect_itsmeOnbording')
  ),
}, 
{
  path: PUBLIC_ROUTE.COMMINGSOON,
  component: lazy(() =>
    import('@iso/containers/Pages/ComingSoon')
  ),
}, 
{
  path: PUBLIC_ROUTE.MULTIUSER,
  component: lazy(() => import('@iso/containers/Pages/SignIn/ItsmeMultiUser')),
},
{
  path: PUBLIC_ROUTE.REJECTAPPLICATION,
  exact: true,
  component: lazy(() =>
    import('@iso/containers/Frontend/RejectApplication')
  ),
},
];
function PrivateRoute({ children, ...rest }) {
  const isLoggedIn = useSelector((state) => getCookie('id_token'));

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isLoggedIn ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}
function PrivateRoutes({ children, ...rest }) {
  const isLoggedIn = useSelector((state) => getCookie('id_token'));

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isLoggedIn ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default function Routes() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loader />}>
        <Router>
          <Switch>
            {publicRoutes.map((route, index) => (
              <Route key={index} path={route.path} exact={route.exact}>
                <route.component />
              </Route>
            ))}
            <PrivateRoute path="/dashboard" key={2}>
              <Dashboard />
            </PrivateRoute>
            <Route key={1}>
              <RedirectTo404 />
            </Route>
            {publicRoutes.map((route, index) => (
              <PrivateRoutes path={route.path}  key={index}>
              <route.component />
            </PrivateRoutes>
            ))}
          </Switch>
        </Router>
      </Suspense>
    </ErrorBoundary>
  );
}

function RedirectTo404() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.state);
  const id = queryParams.get('id');

  // Check if ID exists
  if (id) {
    return <Redirect to="/investor-dashboard" />;
  } else {
    return <Redirect to={PUBLIC_ROUTE.PAGE_404} />;
  }
}

  // return (
  //   <ErrorBoundary>
  //     <Suspense fallback={<Loader />}>
  //       <Router>
  //         <Switch>
  //           {publicRoutes.map((route, index) => (
  //             <Route key={index} path={route.path} exact={route.exact}>
  //               <route.component />
  //             </Route>
  //           ))}
  //           <PrivateRoute path="/dashboard">
  //             <Dashboard />
  //           </PrivateRoute>
  //           <Route>
  //             <Redirect to={PUBLIC_ROUTE.PAGE_404} />
  //           </Route>
  //         </Switch>
  //       </Router>
  //     </Suspense>
  //   </ErrorBoundary>
  // );
// }
